import Alpine from 'alpinejs';
// start after all footer scripts ran, so plugins bundling their own Alpine
// (webkfz, mobile) can register components first and take precedence
const startAlpine = () => {
  if(typeof window.Alpine === 'undefined') {
    window.Alpine = Alpine;
    window.Alpine.start();
  }
};

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startAlpine);
} else {
  startAlpine();
}